import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {ITokenizeResult} from '../../store';

@Module({name: 'deepLink', namespaced: true})
class DeepLinkModule extends VuexModule {
	tokenizeResult: ITokenizeResult | null = null;

	@Action
	handleDeepLink(url: string) {
		const path = url.replace(/.*?:\/\//g, '');
		const query = path.split('?')[1];
		if(query) {
			const params = new URLSearchParams(query);
			const type = params.get('type');
			switch(type) {
				case 'tokenize':
					const rawPayload = params.get('payload');
					if(rawPayload) {
						const payload = JSON.parse(rawPayload);
						if(
							'signedToken' in payload && (payload.signedToken === null || typeof payload.signedToken === 'string') &&
							'accountId' in payload && (payload.accountId === null || typeof payload.accountId === 'string') &&
							'cvv' in payload && (payload.cvv === null || typeof payload.cvv === 'string')
						) {
							this.setTokenizeResult(payload);
							break;
						}
					}
					console.error('No valid payload found in deep link');
					break;
				default:
					console.error('Unknown deep link type: ', type);
					break;
			}
		}
	}

	@Mutation
	setTokenizeResult(payload: ITokenizeResult) {
		this.tokenizeResult = payload;
	}

	@Mutation
	clearTokenizeResult() {
		this.tokenizeResult = null;
	}
}


export {
	DeepLinkModule
};
